<div class="sidebar included">
	<app-sidebar-header [title]="'Price Breakdown'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>

		<div class="price-breakdown-list--title border">Flights</div>
		<ng-container *ngFor="let passenger of passengers">
			<div class="price-breakdown-count border" *ngIf="booked_trip.passengers[passenger] > 0">
				<app-svg class="price-breakdown__icon" svg="sprite.svg#color_icon--plane" aria-hidden="true" [alt]="'Plane icon'"></app-svg>
				<div class="price-breakdown-label">
					<div class="price-breakdown-title">
						<span class="destination">{{booked_trip.passengers[passenger]}}x {{passenger}}</span>
					</div>
					<div class="price-right">
						100 {{ environment.currency.symbol }}
					</div>
				</div>
			</div>
		</ng-container>

		<div class="price-breakdown-count price-breakdown-count--total border">
			<div class="price-breakdown-label">
				<div class="price-breakdown-title ">
					Total
				</div>

				<div class="price-right bold">
					{{ getSumlItem('tickets') }} {{ environment.currency.symbol }}
				</div>
			</div>

		</div>

		<div class="fare-conditions-link__wrapper">
			<a class="link" (click)="TAP_handleFareAndTaxes()" aria-label="Open a new window fare and taxes information" href="javascript:;" role="button">Fare and taxes information</a>
		</div>

		<div class="price-breakdown-list" *ngIf="items_summary.length">
			<div class="price-breakdown-list--title border">Extras</div>

			<ul class="body border" *ngFor="let item of items_summary; let i = index">

				<li *ngFor="let summary of TAP_filterItemsSummary(item.summary); let j = index" class="extras-feature extras-feature__price-breakdown ">
					<div class="extras-feature__label">
						{{ summary.total | number }}x {{summary.label}}
						<span class="lighter">{{ item.flight.departure.airport.location.city }} - {{ item.flight.arrival.airport.location.city }}</span>
					</div>
					<span class="price">{{summary.value}}€</span>
				</li>
			</ul>

		</div>

		<div class="price-breakdown-list">
			<div class="price-breakdown-list--title border">Discounts</div>

			<ul class="body border">
				<li class="extras-feature extras-feature__price-breakdown">
					<div class="extras-feature__label">
						<span class="lighter">Promocode</span>
					</div>
					<span class="price"> - 20,00{{ environment.currency.symbol }}</span>
				</li>
			</ul>

		</div>

	</div>

	<div class="sidebar-flight-extras">
		<ul class="body">
			<li class="extras-feature">
				<div class="extras-feature__label">
					<h3><strong>Total for all passengers</strong></h3>
				</div>
				<p><strong>{{ total_summary }}€</strong></p>
			</li>
		</ul>
	</div>


	<div #sidebar__footer class="sidebar__footer ">
	</div>

</div>
